import RouterSetup from './RouterSetup';
import './index.css'
function App() {
  return (
    <>
      <RouterSetup />
    </>
  );
}

export default App;
